import React, { useMemo } from 'react';
import { Button, Dropdown, Space, type MenuProps } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { getDataModelDropdownItems, DataSourceMapping, PULSE4_DASHBOARDS_KEY } from '../utils';

interface Props {
  // current tab key
  tabKey: string;
  // current data source
  dataSource: string;
  onChange: (dataSource: string) => void;
}
const DataSourceSelection = (props: Props) => {
  const { tabKey, dataSource = 'all', onChange } = props;
  const dataModelItems = useMemo(
    () => getDataModelDropdownItems(),
    []
  );


  // Hidden data source dropdown under pulse4.0 tab
  if (tabKey === PULSE4_DASHBOARDS_KEY) return null;

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        selectedKeys: [dataSource],
        items: dataModelItems as MenuProps['items'],
        onClick: ({ key }) => {
          onChange?.(key)
        },
      }}
    >
      <Button>
        <Space>
          { DataSourceMapping[dataSource] }
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  )
};
export default DataSourceSelection;